/* eslint-disable jsx-a11y/accessible-emoji */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef } from "react";
import styles from "./SelfAssessmentUi.module.css";
import { modalState } from "../voice-agent/InactivityModalState";
import VoiceService from "../voice-agent/VH-Myra-FrontEnd";
import MyraInteraction from "./MyraInteractionController";
import checkBrowserSupport from "./browserDetect";
import { LOGO } from "./GSA_CONSTANTS";

export function MyraFab({ onFabTap, onPickChat, onPickVoice, isFabExpanded, isBubbleVisible, onDismissBubble, statusText }) {
  const [showText, setShowText] = useState(true);
  const [mode, setMode] = useState(MyraInteraction.getMode());
  const [isAgentSpeaking, setIsAgentSpeaking] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const modalRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        MyraInteraction.closeFab();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const unsubMode = MyraInteraction.on("modeChange", ({ mode }) => {
      setMode(mode);
    });

    // Listen to voice service state changes
    const checkVoiceState = () => {
      if (window.VoiceService) {
        const isSpeaking = window.VoiceService._isAgentSpeaking || false;
        const isListen = window.VoiceService._isListening || false;
        setIsAgentSpeaking(isSpeaking);
        setIsListening(isListen);
      }
    };

    // Initial check
    checkVoiceState();

    // Set up interval to check voice state (or use callbacks if available)
    const interval = setInterval(checkVoiceState, 500);

    // Also listen to VoiceService callbacks if available
    if (VoiceService?._callbacks) {
      const originalOnAgentSpeechStart = VoiceService._callbacks.onAgentSpeechStart;
      const originalOnAgentSpeechEnd = VoiceService._callbacks.onAgentSpeechEnd;
      const originalOnListeningStart = VoiceService._callbacks.onListeningStart;
      const originalOnListeningStop = VoiceService._callbacks.onListeningStop;

      VoiceService._callbacks.onAgentSpeechStart = () => {
        setIsAgentSpeaking(true);
        if (originalOnAgentSpeechStart) originalOnAgentSpeechStart();
      };

      VoiceService._callbacks.onAgentSpeechEnd = () => {
        setIsAgentSpeaking(false);
        if (originalOnAgentSpeechEnd) originalOnAgentSpeechEnd();
      };

      VoiceService._callbacks.onListeningStart = () => {
        setIsListening(true);
        if (originalOnListeningStart) originalOnListeningStart();
      };

      VoiceService._callbacks.onListeningStop = () => {
        setIsListening(false);
        if (originalOnListeningStop) originalOnListeningStop();
      };
    }

    return () => {
      if (unsubMode) unsubMode();
      clearInterval(interval);
    };
  }, []);
  const getBubbleText = () => {
    if (!mode) {
      return "Press to ask me anything";
    }

    if (mode === "chat" || mode === "button") {
      return "";
    }

    if (mode === "voice") {
      if (isAgentSpeaking) {
        return "Speaking...";
      } else if (isListening) {
        return statusText;
      }
      return "";
    }

    return "";
  };
  const shouldShowBubble = () => {
    if (!showText) return false;
    if (!isBubbleVisible) return false;

    // Don't show bubble if text is empty
    const bubbleText = getBubbleText();
    if (!bubbleText) return false;

    return true;
  };

  return (
    // On Tap of the Fab Openning Chat - TODO: Remove onClick from here to enable chat/voice selection
    <div ref={modalRef} className={styles.myraFab} id="myraFab" onClick={onPickChat}>
      {/* Expand options — shown when fab is expanded */}
      <div className={`${styles.myraExpand} ${isFabExpanded ? styles.myraExpandOpen : ""}`}>
        <div className={styles.myraOpt} onClick={onPickChat}>
          <svg viewBox="0 0 24 24">
            <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z" />
          </svg>
          <span>Chat with Myra</span>
        </div>
        <div className={styles.myraOpt} onClick={onPickVoice}>
          <svg viewBox="0 0 24 24">
            <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.91-3c-.49 0-.9.36-.98.85C16.52 14.2 14.47 16 12 16s-4.52-1.8-4.93-4.15c-.08-.49-.49-.85-.98-.85-.61 0-1.09.54-1 1.14.49 3 2.89 5.35 5.91 5.78V20c0 .55.45 1 1 1s1-.45 1-1v-2.08c3.02-.43 5.42-2.78 5.91-5.78.1-.6-.39-1.14-1-1.14z" />
          </svg>
          <span>Speak to Myra</span>
        </div>
      </div>

      {/* FAB row — button + bubble */}
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {/* Main FAB button */}
        <button className={styles.myraFabBtn} onClick={onFabTap}>
          <svg viewBox="0 0 24 24" style={{ width: 14, height: 14 }}>
            <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
          </svg>
          <span>Myra</span>
          <div className={styles.fabDot} />
        </button>

        {/* Bubble - only show when visible */}
        {shouldShowBubble() && getBubbleText() && (
          <div className={styles.myraBubble} id="mBub">
            {getBubbleText()}
            <button
              className={styles.bubbleX}
              onClick={(e) => {
                e.stopPropagation();
                setShowText(false);
              }}
            >
              &times;
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// ChatPanel — bottom sheet
// ─────────────────────────────────────────────
export function ChatPanel({ messages, onClose, onSend, onSwitchVoice, onSwitchButton, isChatLoading }) {
  const inputRef = useRef(null);
  const msgsRef = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const [mode, setMode] = useState(MyraInteraction.getMode());
  const [isDragging, setIsDragging] = useState(false);
  const dragStartY = useRef(null);
  const dragStartHeight = useRef(null);
  const panelRef = useRef(null);
  const getDefaultHeight = () =>
    window.innerWidth <= 768
      ? window.innerHeight * 0.5 // mobile: 50%
      : window.innerHeight * 0.55; // desktop: 55%

  const [panelHeight, setPanelHeight] = useState(getDefaultHeight);
  const [isExpanded, setIsExpanded] = useState(false);

  const MIN_HEIGHT = 200;
  const MAX_HEIGHT = window.innerHeight - 24;

  const handleDragStart = (e) => {
    // support both mouse and touch
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    dragStartY.current = clientY;
    dragStartHeight.current = panelHeight;
    setIsDragging(true);
    e.preventDefault();
  };

  useEffect(() => {
    const handleDragMove = (e) => {
      if (!isDragging) return;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      // dragging UP increases height, dragging DOWN decreases
      const delta = dragStartY.current - clientY;
      const newHeight = Math.min(MAX_HEIGHT, Math.max(MIN_HEIGHT, dragStartHeight.current + delta));
      setPanelHeight(newHeight);
    };

    const handleDragEnd = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      window.addEventListener("mousemove", handleDragMove);
      window.addEventListener("mouseup", handleDragEnd);
      window.addEventListener("touchmove", handleDragMove, { passive: false });
      window.addEventListener("touchend", handleDragEnd);
    }

    return () => {
      window.removeEventListener("mousemove", handleDragMove);
      window.removeEventListener("mouseup", handleDragEnd);
      window.removeEventListener("touchmove", handleDragMove);
      window.removeEventListener("touchend", handleDragEnd);
    };
  }, [isDragging]);

  const handleExpandToggle = () => {
    const EXPANDED_HEIGHT = Math.min(window.innerHeight - 24, 720);
    const DEFAULT_HEIGHT = 480;
    const MOBILE_DEFAULT = window.innerHeight * 0.5;
    const MOBILE_EXPANDED = window.innerHeight * 0.85;

    const isMobile = window.innerWidth <= 768;

    const handleExpandToggle = () => {
      if (!isExpanded) {
        setPanelHeight(isMobile ? MOBILE_EXPANDED : EXPANDED_HEIGHT);
      } else {
        setPanelHeight(isMobile ? MOBILE_DEFAULT : DEFAULT_HEIGHT);
      }
      setIsExpanded((e) => !e);
    };
  };

  useEffect(() => {
    const t = setTimeout(() => {
      // inputRef.current?.focus();
    }, 300);

    return () => clearTimeout(t);
  }, [mode]);

  useEffect(() => {
    if (msgsRef.current) {
      msgsRef.current.scrollTop = msgsRef.current.scrollHeight;
    }
  }, [messages]);

  const handleSend = () => {
    const text = inputValue.trim();
    if (!text || isChatLoading) return;
    const screen = MyraInteraction.getCurrentScreen();
    if (screen === "movement_test_1" || screen === "movement_test_2") {
      window.trackFlutterEvent({
        event_name: "user_input_received",
        context_type: screen,
        input_mode: "chat",
        input_text: text,
        // ...extra,
      });
    }
    onSend(text);
    setInputValue("");
  };
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  const isDesktop = () => {
    return window.innerWidth > 768;
  };
  const handleKeyDown = (e) => {
    if (!isDesktop()) return;

    if (e.key === "Enter") {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div ref={panelRef} className={`${styles.chatPanel} ${isDragging ? styles.chatPanelDragging : ""}`} style={{ height: panelHeight }}>
      <div className={styles.chatDragHandle} onMouseDown={handleDragStart} onTouchStart={handleDragStart}>
        <div className={styles.chatDragBar} />
      </div>

      {/* Header */}
      <div className={styles.chatHdr}>
        <h4>Chat with Myra</h4>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {/* {typeof window !== "undefined" && window.inApp === true && (
            <>
              <button className={styles.chatSwitch} onClick={onSwitchVoice}>
                Switch to Voice
              </button>

              <button className={styles.chatSwitch} onClick={onSwitchButton}>
                Use Buttons
              </button>
            </>
          )} */}
          <button className={styles.chatClose} onClick={onClose} title="Collapse">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>
      </div>

      {/* Messages */}
      <div className={styles.chatMsgs} ref={msgsRef}>
        {messages?.length === 0 && (
          <div className={styles.chatMsg}>
            <div className={styles.chatMyra}>Hi! I'm Myra. Type a message or use the buttons on screen.</div>
          </div>
        )}
        {messages?.map((msg, i) => (
          <div className={styles.chatMsg} key={i}>
            {msg.sender === "myra" ? (
              <div style={{ textAlign: "left" }}>
                <div className={styles.chatMyra}>{msg.text}</div>
              </div>
            ) : (
              <div style={{ textAlign: "right" }}>
                <div className={styles.chatUser}>{msg.text}</div>
              </div>
            )}
          </div>
        ))}
        {isChatLoading && (
          <div className={styles.chatTypingIndicator}>
            <span />
            <span />
            <span />
          </div>
        )}
      </div>

      {/* Input */}
      <div className={styles.chatInputRow}>
        <input ref={inputRef} value={inputValue} onChange={handleInputChange} className={styles.chatIn} inputMode="text" placeholder={isChatLoading ? "Myra is typing…" : "Type your question…"} type="text" {...(isDesktop() && { onKeyDown: handleKeyDown })} />
        <button className={styles.chatSend} onClick={handleSend}>
          {isChatLoading ? (
            <span style={{ fontSize: 12 }}>...</span>
          ) : (
            <svg viewBox="0 0 24 24">
              <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// VoicePanel — bottom sheet
// ─────────────────────────────────────────────
export function VoicePanel({ isAgentSpeaking, onClose, onSwitchChat, onSwitchButton, onMicRequest, statusText }) {
  const [micState, setMicState] = React.useState("checking");
  const [deviceMessage, setDeviceMessage] = React.useState("");
  const [issAgentSpeaking, setIssAgentSpeaking] = useState(false);
  const [isListening, setIsListening] = useState(false);

  const checkPermissionState = async () => {
    try {
      if (navigator.permissions && navigator.permissions.query) {
        const status = await navigator.permissions.query({ name: "microphone" });
        setMicState(status.state);

        status.onchange = () => {
          console.log("[VoicePanel] Permission changed to:", status.state);
          setMicState(status.state);
        };
      } else {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
          stream.getTracks().forEach((track) => track.stop());
          setMicState("granted");
        } catch (err) {
          setMicState(err.name === "NotAllowedError" ? "denied" : "prompt");
        }
      }
    } catch (error) {
      console.error("[VoicePanel] Permission check failed:", error);
      setMicState("prompt");
    }
  };

  React.useEffect(() => {
    checkPermissionState();
  }, []);
  React.useEffect(() => {
    const handlePermissionGranted = () => {
      console.log("[VoicePanel] Received permission granted event");
      setMicState("granted");
    };

    const handlePermissionDenied = () => {
      console.log("[VoicePanel] Received permission denied event");
      setMicState("denied");
    };

    const handlePermissionCheck = () => {
      checkPermissionState();
    };

    window.addEventListener("mic-permission-granted", handlePermissionGranted);
    window.addEventListener("mic-permission-denied", handlePermissionDenied);
    window.addEventListener("mic-permission-check", handlePermissionCheck);

    return () => {
      window.removeEventListener("mic-permission-granted", handlePermissionGranted);
      window.removeEventListener("mic-permission-denied", handlePermissionDenied);
      window.removeEventListener("mic-permission-check", handlePermissionCheck);
    };
  }, []);

  useEffect(() => {
    // Listen to voice service state changes
    const checkVoiceState = () => {
      if (VoiceService) {
        const isSpeaking = VoiceService._isAgentSpeaking || false;
        const isListen = VoiceService._isListening || false;
        setIssAgentSpeaking(isSpeaking);
        setIsListening(isListen);
      }
    };

    // Initial check
    checkVoiceState();

    // Set up interval to check voice state (or use callbacks if available)
    const interval = setInterval(checkVoiceState, 500);

    // Also listen to VoiceService callbacks if available
    if (VoiceService?._callbacks) {
      const originalOnAgentSpeechStart = VoiceService._callbacks.onAgentSpeechStart;
      const originalOnAgentSpeechEnd = VoiceService._callbacks.onAgentSpeechEnd;
      const originalOnListeningStart = VoiceService._callbacks.onListeningStart;
      const originalOnListeningStop = VoiceService._callbacks.onListeningStop;

      VoiceService._callbacks.onAgentSpeechStart = () => {
        setIssAgentSpeaking(true);
        if (originalOnAgentSpeechStart) originalOnAgentSpeechStart();
      };

      VoiceService._callbacks.onAgentSpeechEnd = () => {
        setIssAgentSpeaking(false);
        if (originalOnAgentSpeechEnd) originalOnAgentSpeechEnd();
      };

      VoiceService._callbacks.onListeningStart = () => {
        setIsListening(true);
        if (originalOnListeningStart) originalOnListeningStart();
      };

      VoiceService._callbacks.onListeningStop = () => {
        setIsListening(false);
        if (originalOnListeningStop) originalOnListeningStop();
      };
    }

    return () => {
      clearInterval(interval);
    };
  }, []);

  // Build device-specific instructions whenever state flips to denied
  React.useEffect(() => {
    if (micState !== "denied") return;

    const ua = navigator.userAgent.toLowerCase();
    const isMac = /macintosh|mac os x/.test(ua);
    const isWindows = /win/.test(ua);
    const isIPhone = /iphone/.test(ua);
    const isIPad = /ipad/.test(ua);
    const isAndroid = /android/.test(ua);

    if (isMac) {
      setDeviceMessage("To enable it, open System Settings → Privacy & Security → Microphone and make sure your browser is toggled On. Then come back and refresh this page.");
    } else if (isWindows) {
      setDeviceMessage("To enable it, open Settings → Privacy & Security → Microphone and make sure your browser is set to Allow. Then come back and refresh this page.");
    } else if (isIPhone || isIPad) {
      setDeviceMessage("To enable it, go to Settings → Apps → Safari → Microphone and set it to Allow or Ask. Then come back and refresh this page.");
    } else if (isAndroid) {
      setDeviceMessage("To enable it, go to Settings → Apps → Chrome → Permissions → Microphone and set it to Allow. Then come back and refresh this page.");
    } else {
      setDeviceMessage("To enable it, check your browser or system settings for microphone permissions.");
    }
  }, [micState]);

  const handleAllowMic = () => {
    if (onMicRequest) onMicRequest();
  };

  // Header is always the same — extract to avoid repeating it
  const header = (
    <div className={styles.voicePanelHdr}>
      <h4>Speaking to Myra</h4>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <button className={styles.chatSwitch} onClick={onSwitchChat}>
          Switch to Chat
        </button>
        <button className={styles.chatSwitch} onClick={onSwitchButton}>
          Use Buttons
        </button>
        <button className={styles.chatClose} onClick={onClose} title="Collapse">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 9l-7 7-7-7" />
          </svg>
        </button>
      </div>
    </div>
  );

  // Still checking — show nothing in the body to avoid flicker
  if (micState === "checking") {
    return <div className={styles.voicePanel}>{header}</div>;
  }

  // User has not yet responded to the browser prompt
  // if (micState === "prompt") {
  //   return (
  //     <div className={styles.voicePanel}>
  //       {header}
  //       <div className={styles.voiceStatus}>
  //         {/* <p>Myra needs microphone access to hear you.</p> */}
  //         <p className={styles.voiceHint}>To speak with me, you’ll need to grant microphone access. If you’d prefer not to, you can always chat with me instead</p>
  //         <button className={styles.introARButton} onClick={handleAllowMic}>
  //           Grant Mic Access
  //         </button>
  //       </div>
  //     </div>
  //   );
  // }

  // User explicitly blocked the browser prompt — show device instructions
  if (micState === "denied") {
    return (
      <div className={styles.voicePanel}>
        {header}
        <div className={styles.voiceStatus}>
          <p>Microphone access was blocked.</p>
          <p className={styles.voiceHint}>{deviceMessage}</p>
        </div>
      </div>
    );
  }
  if (micState === "prompt") {
    return (
      <div className={styles.voicePanel}>
        {header}
        <div className={styles.voiceStatus}>
          <p>Mic access is needed for Myra to hear your questions. If you prefer not to allow mic access, you can select the Chat option next to Talk. Or, start the Guided Self-Assessment anytime without asking Myra questions.</p>
        </div>
      </div>
    );
  }

  // micState === 'granted' — normal speaking/listening view
  return (
    <div className={styles.voicePanel}>
      {header}
      <div className={styles.voiceStatus}>
        <div className={styles.voiceCircle}>
          <svg viewBox="0 0 24 24">
            <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.91-3c-.49 0-.9.36-.98.85C16.52 14.2 14.47 16 12 16s-4.52-1.8-4.93-4.15c-.08-.49-.49-.85-.98-.85-.61 0-1.09.54-1 1.14.49 3 2.89 5.35 5.91 5.78V20c0 .55.45 1 1 1s1-.45 1-1v-2.08c3.02-.43 5.42-2.78 5.91-5.78.1-.6-.39-1.14-1-1.14z" />
          </svg>
        </div>
        <p>
          <p>{issAgentSpeaking ? "Myra is speaking…" : isListening ? statusText : ""}</p>
        </p>
        <p className={styles.voiceHint}>Speak naturally. Myra will guide you.</p>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// IntroARModeCard — shown on the Intro AR screen

export const InactivityModalManager = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Subscribe to modal state changes
    const unsubscribe = modalState.subscribe((visible) => {
      setIsVisible(visible);
    });

    // Listen for VoiceService events
    const handleShowModal = () => {
      modalState.show();
    };

    document.addEventListener("showInactivityModal", handleShowModal);

    return () => {
      unsubscribe();
      document.removeEventListener("showInactivityModal", handleShowModal);
    };
  }, []);

  const handleClose = () => {
    modalState.hide();

    // Dispatch resume event for other components
    document.dispatchEvent(
      new CustomEvent("inactivityModalResume", {
        detail: { timestamp: Date.now() },
      }),
    );
  };

  return <InactivityModal isVisible={isVisible} onClose={handleClose} />;
};

// Mic Permission Modal
export const MicPermissionModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [deviceMessage, setDeviceMessage] = useState("");

  useEffect(() => {
    const handlePermissionDenied = () => {
      console.log("[MicPermissionModal] Event received: micPermissionDenied");
      setIsVisible(true);
    };

    document.addEventListener("micPermissionDenied", handlePermissionDenied);

    return () => {
      document.removeEventListener("micPermissionDenied", handlePermissionDenied);
    };
  }, []);

  useEffect(() => {
    if (isVisible) {
      const userAgent = navigator.userAgent.toLowerCase();
      const isMac = /macintosh|mac os x/.test(userAgent);
      const isWindows = /win/.test(userAgent);
      const isIPhone = /iphone/.test(userAgent);
      const isIPad = /ipad/.test(userAgent);
      const isAndroid = /android/.test(userAgent);

      if (isMac) {
        setDeviceMessage("To enable it, open System Settings → Privacy & Security → Microphone and make sure your browser is toggled On. Then come back and refresh this page.");
      } else if (isWindows) {
        setDeviceMessage("To enable it, open Settings → Privacy & Security → Microphone and make sure your browser is set to Allow. Then come back and refresh this page.");
      } else if (isIPhone || isIPad) {
        setDeviceMessage("To enable it, go to Settings → Apps → Safari → Microphone and set it to Allow or Ask. Then come back and refresh this page.");
      } else if (isAndroid) {
        setDeviceMessage("To enable it, go to Settings → Apps → Chrome → Permissions → Microphone and set it to Allow. Then come back and refresh this page.");
      } else {
        // Fallback for other devices
        setDeviceMessage("To enable it, check your browser/system settings for microphone permissions.");
      }
    }
  }, [isVisible]);

  const handleClose = () => {
    console.log("[MicPermissionModal] Closing modal");
    setIsVisible(false);
  };

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains(styles.modalBackdrop)) {
      handleClose();
    }
  };

  console.log("[MicPermissionModal] Rendering, isVisible:", isVisible);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.micPermModal} onClick={handleBackdropClick}>
      <div className={styles.micPermModalContent}>
        <h3 className={styles.micPermModalTitle}>Microphone Access Needed</h3>
        <p className={styles.micPermModalHeading}>Mic access is needed for Myra to hear your questions. If you prefer not to allow mic access, you can select the Chat option next to Talk. Or, start the Guided Self-Assessment anytime without asking Myra questions.</p>
        <p className={styles.micPermModalText}>{deviceMessage}</p>
        <button onClick={handleClose} className={styles.micPermModalBtn}>
          OK
        </button>
      </div>
    </div>
  );
};

export const InactivityModal = ({ isVisible, onClose }) => {
  // Handle ESC key
  useEffect(() => {
    if (!isVisible) return;

    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };

    document.addEventListener("keydown", handleEsc);
    // Prevent background scrolling
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "";
    };
  }, [isVisible, onClose]);

  // Don't render if not visible
  if (!isVisible) return null;

  // Handle overlay click (click outside modal)
  const handleOverlayClick = (e) => {
    const inactivityData = {
      type: "RESET_INACTIVITY",
      data: { action: "RESET_INACTIVITY" },
    };

    if (window.mayraCode && VoiceService._ws && VoiceService._ws.readyState === WebSocket.OPEN) {
      VoiceService._ws.send(JSON.stringify(inactivityData));
    }
    if (window.mayraCode) {
      window.mayraCode.doSay("Great! We'll pick up right where we left off.", () => {
        if (e.target === e.currentTarget) {
          VoiceService.resumeCompletely();
          onClose();
        }
      });
    }
  };

  return (
    <div className={styles.InactivityModalOverlay} onClick={handleOverlayClick}>
      <div className={styles.InactivityModalModal}>
        <h2 className={styles.InactivityModalHeading}>I have paused...</h2>
        <button className={styles.InactivityModalButton} onClick={onClose}>
          Resume for Myra
        </button>
      </div>
    </div>
  );
};

export const usePreventNavigation = (redirectPath) => {
  // const history = useHistory();
  // useEffect(() => {
  //   const handlePopState = (e) => {
  //     window.location.replace("/");
  //   };

  //   window.addEventListener("popstate", handlePopState);
  //   return () => {
  //     window.removeEventListener("popstate", handlePopState);
  //   };
  // }, [history, redirectPath]);

  // commented because we will show the modal first if user says no it will stay on the same screen else it will redirected to homescreen.

  return;
};

export const RestartPopup = () => {
  const [visible, setVisible] = useState(false);
  let userName = localStorage.getItem("self_name") || "";

  useEffect(() => {
    const popup = document.getElementById("restartPopup");
    if (!popup) return;

    // Observe style changes
    const observer = new MutationObserver(() => {
      const isVisible = popup.style.display !== "none";
      setVisible(isVisible);
    });

    observer.observe(popup, { attributes: true, attributeFilter: ["style"] });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (visible && window.mayraCode) {
      window.mayraCode.doSay(`${userName}, I noticed you weren't able to complete all 10 reps of that test. That's completely okay — it just means this program may not be the right fit right now. For your safety, the best next step is to check in with a licensed provider who can guide you in person.`);
    }
  }, [visible, userName]);

  return (
    <div
      id="restartPopup"
      style={{
        display: "none",
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        zIndex: 9999,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "20px",
          borderRadius: "8px",
          textAlign: "center",
          width: "300px",
        }}
      >
        <h3
          style={{
            marginBottom: "15px",
            fontSize: "18px",
            fontWeight: 600,
          }}
        >
          Assessment Ended
        </h3>
        <p style={{ marginBottom: "20px" }}>{userName}, I noticed you weren't able to complete all 10 reps of that test. That's completely okay — it just means this program may not be the right fit right now. For your safety, the best next step is to check in with a licensed provider who can guide you in person.</p>
        <button
          id="restartOkBtn"
          style={{
            padding: "10px 20px",
            background: "#0d9488",
            border: "none",
            borderRadius: "6px",
            color: "white",
            cursor: "pointer",
          }}
        >
          OK
        </button>
      </div>
    </div>
  );
};
export const MovementBackGuardModal = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Expose a global function Flutter/ondemand-camera can call
    window.showMovementBackGuard = () => setVisible(true);
    window.hideMovementBackGuard = () => setVisible(false);

    return () => {
      window.showMovementBackGuard = null;
      window.hideMovementBackGuard = null;
    };
  }, []);

  if (!visible) return null;

  const handleLeave = () => {
    setVisible(false);

    // Clean up camera and AR resources
    if (window.turnOffCamera) {
      try {
        window.turnOffCamera();
      } catch (e) {
        console.warn(e);
      }
    }
    if (window.destroyOwnedResources) {
      try {
        window.destroyOwnedResources();
      } catch (e) {
        console.warn(e);
      }
    }
    if (window.mayraCode) {
      try {
        window.mayraCode.forceStop();
        window.mayraCode.disableCallback();
      } catch (e) {
        console.warn(e);
      }
    }
    if (window.VoiceService) {
      try {
        window.VoiceService.stopAllVoiceActivity();
        window.VoiceService.stopAgentSpeech();
      } catch (e) {
        console.warn(e);
      }
    }

    // Hide Flutter view, show assessment div
    const flutterRoot = document.getElementById("OnDemandPlayingRoot");
    if (flutterRoot) flutterRoot.style.display = "none";
    const assesDiv = document.getElementById("assesmentDiv");
    if (assesDiv) assesDiv.style.display = "block";

    // Clear session data
    localStorage.removeItem("trSessionId");
    localStorage.removeItem("assessmentData");
    localStorage.removeItem("userCondition");
    localStorage.removeItem("loadSelf");
    localStorage.removeItem("noCameraMode");
    localStorage.removeItem("runStep");
    localStorage.removeItem("dataAfterInfo");
    window.trSessionId = null;

    window.location.href = "/";
  };

  const handleStay = () => {
    setVisible(false);
    // Re-push the dummy history entry so the guard stays armed
    window.history.pushState({ movementGuard: true }, "");
    // Resume no-camera flow if applicable
    if (window.getNoCameraMode?.() && typeof window.resumeNoCameraFromExit === "function") {
      window.resumeNoCameraFromExit();
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 99999,
        padding: "16px",
        animation: "fadeIn 0.2s ease",
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) handleStay();
      }}
    >
      <div
        style={{
          background: "#ffffff",
          borderRadius: "16px",
          maxWidth: "400px",
          width: "100%",
          maxHeight: "90vh",
          overflowY: "auto",
          boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
        }}
      >
        <div style={{ padding: "24px 20px", textAlign: "center" }}>
          <div style={{ fontSize: "32px", marginBottom: "8px" }}>⚠️</div>

          <h2
            style={{
              fontSize: "17px",
              fontWeight: 700,
              color: "#0f172a",
              textAlign: "center",
              marginBottom: "4px",
              marginTop: 0,
            }}
          >
            Leave the movement check?
          </h2>

          <p
            style={{
              fontSize: "13px",
              color: "#6b7280",
              textAlign: "center",
              marginBottom: "20px",
              lineHeight: 1.5,
            }}
          >
            If you go back now, your movement check progress will be lost and you'll need to restart the assessment.
          </p>

          {/* Primary — leave (danger) */}
          <button
            onClick={handleLeave}
            style={{
              display: "block",
              width: "100%",
              padding: "13px",
              borderRadius: "8px",
              border: "2px solid #ef4444",
              background: "#ffffff",
              color: "#dc2626",
              fontFamily: "'DM Sans', sans-serif",
              fontSize: "14px",
              fontWeight: 700,
              cursor: "pointer",
              marginBottom: "10px",
              transition: "background 0.2s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#fef2f2")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#ffffff")}
          >
            Yes, leave and go to home
          </button>

          {/* Secondary — stay (teal link, matches ehBack) */}
          <button
            onClick={handleStay}
            style={{
              display: "block",
              textAlign: "center",
              fontSize: "13px",
              color: "#0d9488",
              cursor: "pointer",
              marginTop: "4px",
              fontWeight: 500,
              background: "none",
              border: "none",
              fontFamily: "'DM Sans', sans-serif",
              width: "100%",
              padding: "8px",
            }}
          >
            Stay and continue
          </button>
        </div>
      </div>
    </div>
  );
};
export const LoginBackGuardModal = () => {
  useEffect(() => {
    window.showLoginBackGuard = () => {
      if (window._loginBackGuardHandler) {
        window.removeEventListener("popstate", window._loginBackGuardHandler);
        window._loginBackGuardHandler = null;
      }

      document.querySelector("html").classList = ["wait-flutter"];

      const flutterRoot = document.getElementById("OnDemandPlayingRoot");
      if (flutterRoot) flutterRoot.style.display = "none";

      const assesmentDiv = document.getElementById("assesmentDiv");
      if (assesmentDiv) assesmentDiv.style.display = "block";

      if (window.setHideElementsElm) window.setHideElementsElm(false);

      localStorage.removeItem("loadSelf");
      localStorage.removeItem("startedSelf");

      document.body.style = "";
      window.clickedOnceOpen = false;
    };

    return () => {
      window.showLoginBackGuard = null;
    };
  }, []);
  return null;
};
export const BrowserBlockScreen = ({ featureType = "gsa" }) => {
  const [result, setResult] = useState(null);

  useEffect(() => {
    const check = checkBrowserSupport(featureType);
    console.log("Browser Check Result:", check);
    if (!check.isSupported) {
      setResult(check);
    }
  }, [featureType]);

  // Browser is supported — render nothing, app continues normally
  if (!result) return null;

  const { message } = result;

  return (
    <div className={styles.deviceOverlay}>
      <div className={styles.deviceCard}>
        {/* Virdio Logo */}
        <div className={styles.deviceLogoArea}>
          <img
            src={LOGO}
            alt="Virdio Health"
            className={styles.deviceLogo}
            onError={(e) => {
              // Fallback if logo path differs — show text instead
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "block";
            }}
          />
          <span style={{ display: "none" }} className={{ ...styles.deviceLogoFallback }}>
            Virdio Health
          </span>
        </div>

        {/* Heading */}
        <p className={styles.deviceHeading}>{message.heading}</p>

        {/* Full device/browser list (unknown device only) */}
        {message.showFullList && (
          <div className={styles.deviceListContainer}>
            {message.fullList.map((item) => (
              <div key={item.device} style={styles.deviceListRow}>
                <span className={styles.listDevice}>{item.device}</span>
                <span className={styles.listDash}>—</span>
                <span className={styles.listBrowsers}>{item.browsers}</span>
              </div>
            ))}
          </div>
        )}

        {/* Action line */}
        <p className={styles.deviceAction}>{message.action}</p>

        {/* Footer / explanation */}
        <p className={styles.deviceFooter}>{message.footer}</p>
      </div>
    </div>
  );
};
